import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, Route, UrlSegment } from '@angular/router';
import { Observable, of } from 'rxjs';
import { Globals } from '../globals/globals';
import { UserLogged } from '../models/data/userLogged.model';
import { UtilsService } from '../services/utils/utils.service';
import { UserConfiguration } from '../models/data/userConfiguration.model';


@Injectable({
  providedIn: 'root'
})

export class AuthGuard  {

  constructor(
    public globals: Globals,
    public router: Router,
    private utilsService: UtilsService
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      if (this.globals.userLogged == undefined) {
        if (localStorage.getItem("userLogged") != undefined){
            this.globals.userLogged = new UserLogged();
            this.globals.userLogged = JSON.parse(localStorage.getItem("userLogged")!);
            this.utilsService.setLanguageTranslateAndDateFormat().subscribe();
            let _conf: UserConfiguration = new UserConfiguration();
            _conf = JSON.parse(this.globals.userLogged!.configuration!);
            this.globals.theme = _conf.theme;
            return true;
        } else {
            this.utilsService.clearStorage();
            this.router.navigate(["/login"], { queryParams: { returnUrl: state.url } });
            return false;
        }
      } else {
        return true;
      }
  }
}
